import Api from '../../literably-ui/api/api';
import windowWrapper from '../../literably-ui/utils/window-wrapper';
import { Grader, GraderLogin } from './domains/grader';

export default class LiterablyApi extends Api {
  private readonly headers: Record<string, string> = { 'X-CSRFToken': windowWrapper.get<string>('csrf_token') };

  async createGrader(graderData: Grader): Promise<boolean> {
    const response = await this.request('/grader/', {
      body: JSON.stringify(graderData),
      headers: this.headers,
      method: 'POST',
    });

    const { data } = await response.json();
    return data;
  }

  async loginGrader(graderLoginData: GraderLogin): Promise<void> {
    await this.request('/grader/login', {
      body: JSON.stringify(graderLoginData),
      headers: this.headers,
      method: 'POST',
    });
  }
}
